import { LanguageCodes } from "capitalrx-types";

export const MESSAGE_CATEGORIES = {
  appeal_acknowledgement: "Appeal Acknowledgement",
  approval_reasoning: "Approval Reasoning",
  close_case_reasoning: "Close Case Reasoning",
  // special value, represents two categories.
  close_case_ineligible_fax_reasoning: "Close Case and Ineligible Fax Reasoning",
  denial_reasoning: "Denial Reasoning",
  denial_type: "Denial Type",
  // special value, contains all EPA system message categories.
  epa_system_message: "ePA System Message",
  extension_notification: "Extension Notification",
  ineligible_fax_reasoning: "Ineligible Fax Reasoning",
  letter_messages: "Letter Messages",
  missing_information_request: "Missing Information Request",
  pre_denial_notification: "Pre-Denial Notification",
  question_rationale: "Question Rationale",
  supporting_statement_request: "Supporting Statement Request",
  system_notes: "System Notes",
} as const;

export const EPA_MESSAGE_CATEGORIES = [
  "epa_cdphp_member_not_eligible",
  "epa_curative_member_not_eligible",
  "epa_dual_centennial_not_epa_eligible",
  "epa_drug_not_found",
  "epa_drug_utilization_review",
  "epa_duplicate_case_closed",
  "epa_duplicate_case_denied",
  "epa_duplicate_case_denied_medicare_appeal_ire",
  "epa_duplicate_case_denied_medicare_appeal_alj",
  "epa_duplicate_case_denied_medicare_appeal_mac",
  "epa_duplicate_case_denied_medicare_appeal_jr",
  "epa_duplicate_case_in_progress",
  "epa_other",
  "epa_member_inactive",
  "epa_member_not_eligible",
  "epa_member_not_found",
  "epa_internal_server_error",
  "epa_not_epa_eligible",
  "epa_not_epa_eligible_medicare",
  "epa_part_b_non_delegated",
  "epa_pharmacy_not_found",
  "epa_prescriber_not_found",
  "epa_refill_too_soon",
  "epa_test_claim_pays_with_overrides",
  "epa_test_claim_pays_due_to_pa",
  "epa_test_claim_pays",
] as const;

export type EpaMessageCategory = (typeof EPA_MESSAGE_CATEGORIES)[number];

export type MessageCategory = keyof typeof MESSAGE_CATEGORIES;

export type ApiMessageCategory =
  | Exclude<MessageCategory, "epa_system_message" | "close_case_ineligible_fax_reasoning">
  | EpaMessageCategory;

export const EPA_REASON_CODES = ["BX", "BY", "CC", "CD", "CE", "CF", "CG", "CH", "CJ", "CK", "CM", "CP", "CY", "FM", "FP", "FR"] as const;

export type EpaReasonCode = (typeof EPA_REASON_CODES)[number];

export type MessageTranslation = {
  readonly language_code: LanguageCodes;
  readonly content: string;
  readonly updated_at?: string;
  readonly updated_by?: string;
}
